import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b50aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "field has-addons is-flex-grow-1" }
const _hoisted_4 = { class: "control is-expanded" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "control is-hidden" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-search" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Search", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "card-content" }
const _hoisted_13 = ["id", "onUpdate:modelValue"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_17 = { class: "columns" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column is-narrow is-align-self-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Sort by")
], -1))
const _hoisted_19 = { class: "column" }
const _hoisted_20 = { class: "select is-fullwidth" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "relevance" }, "Relevance", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "element_name" }, "Element name", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpModal = _resolveComponent("HelpModal")!
  const _component_Facet = _resolveComponent("Facet")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTerms) = $event)),
              type: "text",
              placeholder: "Search terms...",
              disabled: _ctx.loading || undefined
            }, null, 8, _hoisted_5), [
              [_vModelText, _ctx.currentTerms]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_HelpModal, {
              "icon-class": "button",
              title: "Help for search",
              data: _ctx.SEARCH_HELP
            }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }]),
              disabled: _ctx.loading || _ctx.noSource || undefined
            }, _hoisted_11, 10, _hoisted_8)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((Object.keys(_ctx.sources) as SearchSource[]), (source) => {
          return (_openBlock(), _createElementBlock("div", { key: source }, [
            _withDirectives(_createElementVNode("input", {
              id: source,
              "onUpdate:modelValue": ($event: any) => ((_ctx.sources[source]) = $event),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
              type: "checkbox"
            }, null, 40, _hoisted_13), [
              [_vModelCheckbox, _ctx.sources[source]]
            ]),
            _hoisted_14,
            _createElementVNode("label", {
              for: source,
              class: "is-capitalized"
            }, _toDisplayString(source), 9, _hoisted_15)
          ]))
        }), 128)),
        (_ctx.noSource)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Please select at least one source"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sort) = $event))
              }, _hoisted_23, 512), [
                [_vModelSelect, _ctx.sort]
              ])
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFacets, (_, name) => {
      return (_openBlock(), _createBlock(_component_Facet, {
        key: name,
        name: name,
        values: _ctx.allFacets[name],
        onChange: _ctx.submit,
        modelValue: _ctx.checkedFacets[name],
        "onUpdate:modelValue": ($event: any) => ((_ctx.checkedFacets[name]) = $event)
      }, null, 8, ["name", "values", "onChange", "modelValue", "onUpdate:modelValue"]))
    }), 128))
  ], 32))
}